import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { QueryResult, useLazyQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { KodplanContext } from '../../../../../../../Components/KodplanManager/Context/KodplanContext';
import {
  TEDEKBokforderMeddelandeAVSANDAR_TYPEnum,
  TEDEKBokforderMinBokforderStatusEnum,
  TEDEKBokforderRadLIKVIDSATTEnum,
  TEDEKBokforderSTATUSEnum,
  TEDEKBokforderTYPEnum,
  TEDEKBokforderVariantEnum,
  TEDEKBokforingsmallRadDEB_KREDEnum,
  TEDEKBokforingsmallRadVILLKOR_10Enum,
  TEDEKBokforingsmallRadVILLKOR_1Enum,
  TEDEKBokforingsmallRadVILLKOR_2Enum,
  TEDEKBokforingsmallRadVILLKOR_3Enum,
  TEDEKBokforingsmallRadVILLKOR_4Enum,
  TEDEKBokforingsmallRadVILLKOR_5Enum,
  TEDEKBokforingsmallRadVILLKOR_6Enum,
  TEDEKBokforingsmallRadVILLKOR_7Enum,
  TEDEKBokforingsmallRadVILLKOR_8Enum,
  TEDEKBokforingsmallRadVILLKOR_9Enum,
  TEDOPOrgPersLokTypEnum,
} from '../../../../../../../globalQueryTypes';
import mergeSort from '../../../../../../../Utils/mergeSort';
import { AUTOMATICALLY_ADDED_VALUE_PREFIX } from '../../../../../Leverantor/ObjektVyer/FakturaDel/Components/FakturaDelContextManager/FakturaDelContextManager';
import { BusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { NEWLY_ADDED_ID_PREFIX_FOR_UPDATE } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Const/BusinessDataFormConst';
import {
  FormUpdateAssociatonType,
  getFormUpdateValue,
} from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import KonteringContext, {
  IBokforderKodbehorigheter,
} from '../../../../../_Common/Components/KonteringManager/KonteringContext';
import { KonteringManagerQuery_rtn_EKKodplan__Associations_Kontodelsdef_All__Associations_Kontodel_All__Associations_LokalKontoanvandning_All } from '../../../../../_Common/Components/KonteringManager/Query/_QueryTypes/KonteringManagerQuery';
import {
  BokforderSettingsQuery,
  BokforderSettingsQueryVariables,
  BokforderSettingsQuery_db_EKBokforingsmall_All,
  BokforderSettingsQuery_db_EKBokforingsmall_All__Associations_Rader_All,
} from '../../Queries/BokforderSettingsQuery/_QueryTypes/BokforderSettingsQuery';
import {
  BokforderType,
  BokforderType__Associations_Rader,
} from '../../Queries/_QueryTypes/BokforderType';
import {
  IFranvaroUserOption,
  createLabelText,
  createParamString,
  findFranvaroForUser,
  findKontodelWithLocalusage,
  getAttestanterWithCurrentUserAsReserv,
  getBokforderTypeFromSearchParams,
  getBokforderVariantFromSearchParams,
  getKodplanForBokfOrder,
  sortByOrdningsNr,
  translateOmforingsTypeToBokforderVariant,
} from '../../Utils/BokforderUtils';
import BokforderContext, { IBokforderContext } from './BokforderContext';
import { UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter } from '../../Queries/BokforderKodbehorigheter/_QueryTypes/UserBokforderKodbehorigheterQuery';
import { TSelectedDetail } from '../../../../../../../Types/MasterDetailTypes';
import { IValues } from '../../../../../_StandardRutin/Mutations/ObjectMutations/ObjectUpdateMutationBase';
import { equals } from 'ramda';
import { BokforderQuery_node_TEDEKBokforder } from '../../Queries/_QueryTypes/BokforderQuery';
import { BokforderWrapperContext } from '../../../../Rutiner/Bokforder/Contexts/BokforderWrapperContext';
import { useNavigate, useLocation } from 'react-router';
import { parseParamsValues } from '../../Utils/BokforderKonteringUtils';
import { CreateDialogOpenEnum } from '../../../../Rutiner/Bokforder/Components/BokforderProviderWrapper';
import { UtanordningType } from '../../Queries/_QueryTypes/UtanordningType';
import { EKBokforderSysoptionQuery_db_SYSOptions_All } from '../../../../Rutiner/Bokforder/Queries/_QueryTypes/EKBokforderSysoptionQuery';
import { EK_BOKFORDER_ATTESTANT_EDIT_KONTERING } from '../../../../Rutiner/Bokforder/Const/BokforderSysoptionConsts';
import { createUsersWithKodbehBasedOnType } from '../../Utils/BfoUtanordningUtils';
import { ModelContext } from '../../../../../../../Model/ModelContext/ModelContext';
import { BFO_OPEN_FROM_EKA } from '../../../../../../../Utils/LocalStorage/localStorageKeys';
import {
  KonteringsmallQuery,
  KonteringsmallQueryVariables,
} from '../BokforderCreateDialog/Queries/_QueryTypes/KonteringsmallQuery';
import queryKonteringsmall from '../BokforderCreateDialog/Queries/BokforderKonteringsmallQuery.gql';
import { getKontodelarFromKonteringsMall } from '../../Utils/UtanordningUtils';
import { IKontodel } from '../../../../../_Common/Components/KonteringManager/Query/KonteringManagerQuery';
import { FranvaroContext } from '../../../../../SystemAdministration/ObjektVyer/User/Context/FranvaroContext/FranvaroContext';

export interface ITemplateRow {
  andelProcent: number | null;
  debetOrKredit: TEDEKBokforingsmallRadDEB_KREDEnum | null;
  id: string;
  kommentar: string | null;
  kontodelar: {
    Kontodel1: ITemplateKoddel;
    Kontodel2: ITemplateKoddel;
    Kontodel3: ITemplateKoddel;
    Kontodel4: ITemplateKoddel;
    Kontodel5: ITemplateKoddel;
    Kontodel6: ITemplateKoddel;
    Kontodel7: ITemplateKoddel;
    Kontodel8: ITemplateKoddel;
    Kontodel9: ITemplateKoddel;
    Kontodel10: ITemplateKoddel;
  };
  mallradLopnr: number;
  methodOfLiquidation:
    | KonteringManagerQuery_rtn_EKKodplan__Associations_Kontodelsdef_All__Associations_Kontodel_All__Associations_LokalKontoanvandning_All
    | undefined;
  ordningsNr: number | null;
}

export interface IParamValues {
  [x: string]: string;
}

export interface IBfoUrlParams {
  vernr: string | null;
  bokfar: string | null;
  variant: string | null;
}

export interface IUserBokforderKodbehorigheter
  extends UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter {
  bokforderKodbehorighetUrval: IBokforderKodbehorigheter[];
}

interface IProps {
  settingsQueryResult: QueryResult<
    BokforderSettingsQuery,
    BokforderSettingsQueryVariables
  >;
  selectedDetail: TSelectedDetail;
  editMessageID: string;
  setEditMessageID: React.Dispatch<React.SetStateAction<string>>;
}

export interface ITemplateKoddel {
  kontodel:
    | {
        id: string | undefined;
        BENAMNING: string | null | undefined;
        KONTODEL: string | undefined;
        KontodelBenamning: string | null | undefined;
        __typename: string;
      }
    | null
    | undefined;
  options: {
    canChange: boolean | null;
    validInterval: string | null;
    conditions: TemplateKoddelCondition | null;
  };
}
type TemplateKoddelCondition =
  | TEDEKBokforingsmallRadVILLKOR_1Enum
  | TEDEKBokforingsmallRadVILLKOR_2Enum
  | TEDEKBokforingsmallRadVILLKOR_3Enum
  | TEDEKBokforingsmallRadVILLKOR_4Enum
  | TEDEKBokforingsmallRadVILLKOR_5Enum
  | TEDEKBokforingsmallRadVILLKOR_6Enum
  | TEDEKBokforingsmallRadVILLKOR_7Enum
  | TEDEKBokforingsmallRadVILLKOR_8Enum
  | TEDEKBokforingsmallRadVILLKOR_9Enum
  | TEDEKBokforingsmallRadVILLKOR_10Enum;

export type BfoRowsForTemplateType = {
  id: string;
  MALLRAD_LOPNR: number | null;
};

export enum DefaultBfoVariantEnum {
  VERIFIKATION = 'VERIFIKATION',
}

export const getBokforderVariant = (
  formContextData:
    | BokforderQuery_node_TEDEKBokforder
    | BokforderType
    | UtanordningType
    | null,
  searchParams: string
): TEDEKBokforderVariantEnum | DefaultBfoVariantEnum | null => {
  if (
    formContextData &&
    formContextData.TYP === TEDEKBokforderTYPEnum.BOKFORINGSORDER
  ) {
    const bfoData = formContextData as BokforderType;
    if (bfoData?.OMFORINGSTYP && bfoData.OMFORINGSTYP != null) {
      //Synka med OMFORINGSTYP från backenden
      return translateOmforingsTypeToBokforderVariant(bfoData.OMFORINGSTYP);
    } else if (bfoData?.MALL_ID && bfoData?.MALL_ID !== null) {
      //Hämtar data och det är från en mall
      return TEDEKBokforderVariantEnum.MALL;
    } else {
      // Hämtar data och det är från en tom bfo
      return TEDEKBokforderVariantEnum.TOM;
    }
  } else if (
    formContextData &&
    formContextData.TYP === TEDEKBokforderTYPEnum.UTANORDNING &&
    formContextData.Variant != null
  ) {
    //Utanordning
    const utanordningData = formContextData as UtanordningType;
    return utanordningData.Variant;
  } else {
    const createMode = getBokforderVariantFromSearchParams(searchParams);
    if (createMode !== null) {
      // Scenario när man skapar en ny bfo
      return createMode;
    }
  }
  //Defaultar till TOM. Om man kör undefined så hamnar man in en loop när man skapar ny
  return null;
};

const BokforderContextManager: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const location = useLocation();
  const navigate = useNavigate();
  const formContext = useContext(BusinessDataFormContext);
  const formContextUpdate = formContext?.update;
  const formContextDispatch = formContext?.formStateDispatch;
  const kodplaner = useContext(KodplanContext);
  const konteringContext = useContext(KonteringContext);
  const bokforderWrapperContext = useContext(BokforderWrapperContext);
  const setCreateOptionDialogOpen =
    bokforderWrapperContext.setCreateOptionDialogOpen;
  const { userID } = useContext(ActiveDatabaseContext);
  const { avenyCollectionMap } = useContext(ModelContext);
  const franvaroContext = useContext(FranvaroContext);

  const focusRef = useRef(undefined);
  const [isEditMode, setIsEditMode] = useState(false);
  const [limitedCreateMode, setLimitedCreateMode] = useState<boolean | null>(
    null
  );
  const [isFromEkA, setIsFromEkA] = useState(
    Boolean(localStorage.getItem(BFO_OPEN_FROM_EKA))
  );

  const [paramValues, setParamValues] = useState<IParamValues>({});
  const [bokforderVariant, setBokforderVariant] = useState<
    TEDEKBokforderVariantEnum | DefaultBfoVariantEnum | null
  >(null);
  const [prevSelectedDetail, setPrevSelectedDetail] = useState(
    props.selectedDetail
  );
  const [areYouSureModalOpen, setAreYouSureModalOpen] =
    useState<boolean>(false);
  const [areYouSureModalCallback, setAreYouSureModalCallback] = useState<{
    callback: (args?: any) => void;
  }>({ callback: () => {} });
  const [newRowIndex, setNewRowIndex] = useState(0);
  const [templateRows, setTemplateRows] = useState<ITemplateRow[]>([]);
  const [hasVerifikationFakturabild, setHasVerifikationFakturabild] =
    useState<boolean>(false);
  const [hasVerifikationUnderlag, setHasVerifikationUnderlag] =
    useState<boolean>(false);
  const [tillgodohavandeKundTyp, setTillgohavandeKundTyp] = useState<
    TEDOPOrgPersLokTypEnum | undefined
  >(
    formContext?.isNew
      ? undefined
      : formContext?.data?._Associations?.Kund?._Associations?.OrgPers?._typ
  );
  const [importDialogOpen, setImportDialogOpen] = useState(false);

  const today = useMemo(() => new Date(), []);

  const bokforderDate = useMemo(() => {
    return formContext?.formState?.currentValues?.BOKF_DATUM
      ? new Date(formContext?.formState?.currentValues?.BOKF_DATUM)
      : today;
  }, [formContext?.formState?.currentValues?.BOKF_DATUM, today]);

  const [
    getKonteringsmall,
    { data: konteringsmallarData, loading: konteringsmallarLoading },
  ] = useLazyQuery<KonteringsmallQuery, KonteringsmallQueryVariables>(
    queryKonteringsmall,
    {
      onCompleted: data => {
        const kontodelar: IKontodel[] = getKontodelarFromKonteringsMall(
          data,
          bokforderKodplan?.id ?? '',
          bokforderDate,
          konteringContext.konteringUtils
        );

        const firstRow =
          formContext?.formState.currentValues?._Associations?.Rader?.[0];

        if (firstRow) {
          const newValues: FormUpdateAssociatonType[][] = kontodelar.reduce<
            FormUpdateAssociatonType[][]
          >((formUpdateAssocArray, kontodel) => {
            if (kontodel.aktiv) {
              const formUpdateObject: FormUpdateAssociatonType[] = [
                {
                  associationName: 'Rader',
                  operation: 'Add_Values',
                  id: firstRow.id,
                },
                {
                  associationName: `Kontodel${kontodel.ordningsNr}`,
                  operation: 'Ref',
                  id: kontodel?.id ?? null,
                  values: kontodel?.id ? { id: kontodel?.id } : null,
                },
              ];
              return [...formUpdateAssocArray, formUpdateObject];
            }
            return formUpdateAssocArray;
          }, []);

          if (newValues.length > 0) {
            formContext?.update(newValues);
          }
        }
      },
    }
  );

  const allBokforderUsersWithKodbeh: IUserBokforderKodbehorigheter[] =
    useMemo(() => {
      const allUsersWithBokforderAttestKodbeh =
        createUsersWithKodbehBasedOnType(
          bokforderWrapperContext.allBFOUsers,
          avenyCollectionMap,
          bokforderDate,
          'FOR_BOKFORDER',
          userID ?? '',
          bokforderWrapperContext.isEconomyPersonnel
        );
      return allUsersWithBokforderAttestKodbeh;
    }, [
      avenyCollectionMap,
      bokforderDate,
      bokforderWrapperContext.allBFOUsers,
      bokforderWrapperContext.isEconomyPersonnel,
      userID,
    ]);

  const allUtanordningUsersWithKodbeh: IUserBokforderKodbehorigheter[] =
    useMemo(() => {
      const allUsersWithUtanordningAttestKodbeh =
        createUsersWithKodbehBasedOnType(
          bokforderWrapperContext.allBFOUsers,
          avenyCollectionMap,
          bokforderDate,
          'FOR_UTANORDNING',
          userID ?? '',
          bokforderWrapperContext.isEconomyPersonnel
        );
      return allUsersWithUtanordningAttestKodbeh;
    }, [
      avenyCollectionMap,
      bokforderDate,
      bokforderWrapperContext.allBFOUsers,
      bokforderWrapperContext.isEconomyPersonnel,
      userID,
    ]);

  const bokforderKodplan = useMemo(() => {
    return getKodplanForBokfOrder(
      kodplaner.availableKodplanList,
      bokforderDate
    );
  }, [bokforderDate, kodplaner.availableKodplanList]);

  const isVerifikation = useMemo(() => {
    return (
      bokforderVariant === TEDEKBokforderVariantEnum.KOPIERA ||
      bokforderVariant === TEDEKBokforderVariantEnum.OMBOKFOR ||
      bokforderVariant === TEDEKBokforderVariantEnum.PERIODISERA ||
      bokforderVariant === TEDEKBokforderVariantEnum.VAND ||
      bokforderVariant === DefaultBfoVariantEnum.VERIFIKATION
    );
  }, [bokforderVariant]);

  const urlParams: IBfoUrlParams = useMemo(() => {
    const searchString = location.search.toLowerCase();

    const defaultURLParams: IBfoUrlParams = {
      bokfar: null,
      vernr: null,
      variant: null,
    };

    if (searchString !== '') {
      const searchParams = new URLSearchParams(searchString);

      const urlParams: IBfoUrlParams = {
        bokfar: searchParams.get('bokfar'),
        vernr: searchParams.get('vernr'),
        variant: searchParams.get('variant')?.toLocaleUpperCase('sv-SE') ?? '',
      };

      const hasAllURLParams =
        urlParams.bokfar && urlParams.variant && urlParams.vernr;

      if (
        hasAllURLParams &&
        (bokforderVariant === TEDEKBokforderVariantEnum.TOM ||
          bokforderVariant === null)
      ) {
        if (urlParams.variant === DefaultBfoVariantEnum.VERIFIKATION) {
          setBokforderVariant(DefaultBfoVariantEnum.VERIFIKATION);
          setCreateOptionDialogOpen(CreateDialogOpenEnum.OPENFROMLIST);
        }
      }

      return hasAllURLParams ? urlParams : defaultURLParams;
    }

    return defaultURLParams;
  }, [
    bokforderVariant,
    setCreateOptionDialogOpen,
    setBokforderVariant,
    location.search,
  ]);

  const isAttestant = useMemo(() => {
    const attestRows: BokforderType__Associations_Rader[] =
      formContext?.data?._Associations?.Rader?.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ?? [];

    return attestRows.length > 0;
  }, [formContext?.data?._Associations?.Rader, userID]);

  const attestanterWithCurrentUserAsReserv: IFranvaroUserOption[] = useMemo(
    () =>
      getAttestanterWithCurrentUserAsReserv(
        formContext?.data?._Associations?.Rader ?? [],
        franvaroContext.franvaroReservForData,
        formContext?.data?.TYP
      ),
    [
      formContext?.data?.TYP,
      formContext?.data?._Associations?.Rader,
      franvaroContext.franvaroReservForData,
    ]
  );

  const kontrollattestantWithCurrentUserAsReserv = useMemo(
    () =>
      franvaroContext.franvaroReservForData.find(franvaro =>
        findFranvaroForUser(
          formContext?.formState.currentValues?._Associations?.Kontrollattestant
            ?.id,
          formContext?.data?.TYP,
          today,
          franvaro
        )
      ),
    [
      franvaroContext.franvaroReservForData,
      today,
      formContext?.data?.TYP,
      formContext?.formState.currentValues?._Associations?.Kontrollattestant
        ?.id,
    ]
  );

  const isReservForKontrollattestant = useMemo(
    () =>
      kontrollattestantWithCurrentUserAsReserv !== undefined &&
      (formContext?.formState.currentValues?.KONTROLLATTESTERAD_DATUM == null ||
        (formContext?.formState.currentValues?.KONTROLLATTESTERAD_DATUM !=
          null &&
          formContext?.formState.currentValues?._Associations
            ?.ReservKontrollattestant?.id === userID)),
    [
      kontrollattestantWithCurrentUserAsReserv,
      userID,
      formContext?.formState.currentValues?.KONTROLLATTESTERAD_DATUM,
      formContext?.formState.currentValues?._Associations
        ?.ReservKontrollattestant?.id,
    ]
  );

  const isReservForAttestant = useMemo(
    () =>
      attestanterWithCurrentUserAsReserv.some(
        attestant =>
          !attestant.Attesterat ||
          (attestant.Attesterat && attestant.AttesteratAsCurrentReserv)
      ),
    [attestanterWithCurrentUserAsReserv]
  );

  const everyReservAttesterIsAttesterade = useMemo(
    () =>
      attestanterWithCurrentUserAsReserv.every(
        attestant =>
          attestant.Attesterat ||
          (attestant.Attesterat && attestant.AttesteratAsCurrentReserv)
      ),
    [attestanterWithCurrentUserAsReserv]
  );

  const showAttestantKonteraSwitch: boolean = useMemo(() => {
    const attestantEditKontering = bokforderWrapperContext.sysOptions?.find(
      (option: EKBokforderSysoptionQuery_db_SYSOptions_All) =>
        option?.OptionKey === EK_BOKFORDER_ATTESTANT_EDIT_KONTERING
    )?.OptionData;
    //Blank och Y blir true annars false
    return (attestantEditKontering == undefined ||
      attestantEditKontering === 'Y') &&
      (isAttestant || isReservForAttestant) &&
      formContext?.data?.MinBokforderStatus ===
        TEDEKBokforderMinBokforderStatusEnum.ATT_ATTESTERA
      ? true
      : false;
  }, [
    bokforderWrapperContext.sysOptions,
    formContext?.data?.MinBokforderStatus,
    isAttestant,
    isReservForAttestant,
  ]);

  const templateID =
    formContext?.formState.currentValues?._Associations?.Bokforingsmall?.id ??
    formContext?.formState.currentValues?._Associations?.Bokforingsmall;

  useEffect(() => {
    const newParamValues: IParamValues = parseParamsValues(
      formContext?.formState?.currentValues?.PARAMVALUES
    );
    setParamValues(newParamValues);
  }, [formContext?.formState?.currentValues?.PARAMVALUES]);

  useEffect(() => {
    // Vi går in i redigeringsläge
    // på status: Utkast / Ej godkänd
    const isBestallare =
      formContext?.data?._Associations?.Bestallare?.id === userID;

    if (
      ((formContext?.data?.STATUS === TEDEKBokforderSTATUSEnum.UTKAST ||
        formContext?.data?.STATUS === TEDEKBokforderSTATUSEnum.EJ_GODKAND) &&
        isBestallare) ||
      formContext?.isNew
    ) {
      setIsEditMode(true);
      const todayDateString = today.toLocaleDateString('sv-SE');
      if (
        formContext.formState.currentValues?.TYP ===
          TEDEKBokforderTYPEnum.UTANORDNING &&
        formContext.formState.currentValues?.BOKF_DATUM !== todayDateString
      ) {
        formContext.update([
          {
            operation: 'OwnFields',
            values: { BOKF_DATUM: todayDateString },
          },
        ]);
      }
    } else {
      setIsEditMode(false);
    }
  }, [
    formContext,
    formContext?.data?.STATUS,
    formContext?.data?._Associations?.Bestallare?.id,
    formContext?.formState.currentValues?.TYP,
    formContext?.isNew,
    formContext?.update,
    today,
    userID,
  ]);

  const makeNewRow = useCallback(
    (id: string, newValues?: IValues): FormUpdateAssociatonType[] => {
      let tempValues = { id: id };

      if (newValues) {
        tempValues = { ...tempValues, ...newValues };
      }

      const values: FormUpdateAssociatonType = {
        id: id,
        associationName: 'Rader',
        operation: 'Add_Values',
        values: tempValues,
      };
      return [
        values,
        {
          operation: 'Ref',
          associationName: 'Kodplan',
          id: kodplaner.activeKodplan?.id ?? '',
        },
      ];
    },
    [kodplaner.activeKodplan?.id]
  );

  const updateRow = useCallback(
    (id: string, newValues?: IValues): FormUpdateAssociatonType[] => {
      let tempValues = { id: id };

      if (newValues) {
        tempValues = { ...tempValues, ...newValues };
      }

      const values: FormUpdateAssociatonType = {
        id: id,
        associationName: 'Rader',
        operation: 'Update_Values',
        values: tempValues,
      };
      return [
        values,
        {
          operation: 'Ref',
          associationName: 'Kodplan',
          id: kodplaner.activeKodplan?.id ?? '',
        },
      ];
    },
    [kodplaner.activeKodplan?.id]
  );

  const methodOfLiquidation = useMemo(() => {
    return (
      formContext?.formState?.currentValues?._Associations?.Rader?.reduce(
        (
          prev: TEDEKBokforderRadLIKVIDSATTEnum[],
          curr: BokforderType__Associations_Rader
        ) => {
          if (
            prev.includes(curr.LIKVIDSATT as TEDEKBokforderRadLIKVIDSATTEnum)
          ) {
            return prev;
          } else {
            return [...prev, curr.LIKVIDSATT];
          }
        },
        ['ALLA']
      )?.filter((method: any) => method != undefined) ?? ['ALLA']
    );
  }, [formContext?.formState?.currentValues?._Associations?.Rader]);

  /** When changing templates for Bokforder, return an array of newRows and also sets the state templateRows to that array */
  const makeTemplateRowsArray = useCallback(
    (
      option: BokforderSettingsQuery_db_EKBokforingsmall_All | null,
      rowsFromBokforder?: BfoRowsForTemplateType[] | null
    ) => {
      const templateRowsFromTemplate = option?._Associations?.Rader_All;
      if (!templateRowsFromTemplate) {
        return [];
      }

      const kontodelDefsFromKodplan =
        konteringContext.konteringUtils.getKontodelDefsByKodplanId(
          bokforderKodplan?.id ?? ''
        );

      let methodsOfLiquidation: TEDEKBokforderRadLIKVIDSATTEnum[] = [];

      const sortedRowsfromTemplate = mergeSort(
        templateRowsFromTemplate,
        sortByOrdningsNr
      );

      const filteredRowsFromTemplate = sortedRowsfromTemplate.filter(
        (
          templateRow: BokforderSettingsQuery_db_EKBokforingsmall_All__Associations_Rader_All
        ) => {
          const kontodelWithLocalusage =
            kontodelDefsFromKodplan?.[0]?.kontodelar?.find(
              findKontodelWithLocalusage(templateRow)
            );

          const bokforderRow: BfoRowsForTemplateType | undefined =
            rowsFromBokforder?.find(
              row => row.MALLRAD_LOPNR === templateRow.LOPNR
            );

          const isRowEmpty =
            templateRow._Associations == null &&
            kontodelWithLocalusage == undefined &&
            !(
              templateRow.GILTIG_INTERVALL_1 ||
              templateRow.GILTIG_INTERVALL_2 ||
              templateRow.GILTIG_INTERVALL_3 ||
              templateRow.GILTIG_INTERVALL_4 ||
              templateRow.GILTIG_INTERVALL_5 ||
              templateRow.GILTIG_INTERVALL_6 ||
              templateRow.GILTIG_INTERVALL_7 ||
              templateRow.GILTIG_INTERVALL_8 ||
              templateRow.GILTIG_INTERVALL_9 ||
              templateRow.GILTIG_INTERVALL_10
            );
          return (
            !isRowEmpty && (formContext?.isNew || bokforderRow != undefined)
          );
        }
      );

      const newRows = filteredRowsFromTemplate?.map(
        (
          templateRow: BokforderSettingsQuery_db_EKBokforingsmall_All__Associations_Rader_All,
          index
        ) => {
          const bokforderRow: BfoRowsForTemplateType | undefined =
            rowsFromBokforder?.find(
              row => row.MALLRAD_LOPNR === templateRow.LOPNR
            );

          // Om raden är skapad från en mall och kommer från backenden så använder vi befintligt id
          const id = bokforderRow
            ? bokforderRow.id
            : `${NEWLY_ADDED_ID_PREFIX_FOR_UPDATE}Bokforder_Rad_${index}`;
          const kontodelWithLocalusage =
            kontodelDefsFromKodplan?.[0]?.kontodelar?.find(
              findKontodelWithLocalusage(templateRow)
            );

          if (kontodelWithLocalusage) {
            kontodelWithLocalusage.localUsage?.forEach(localUsage =>
              methodsOfLiquidation.push(localUsage.MALL_TYP as any)
            );
          }

          const kontodelar: {
            Kontodel1: ITemplateKoddel;
            Kontodel2: ITemplateKoddel;
            Kontodel3: ITemplateKoddel;
            Kontodel4: ITemplateKoddel;
            Kontodel5: ITemplateKoddel;
            Kontodel6: ITemplateKoddel;
            Kontodel7: ITemplateKoddel;
            Kontodel8: ITemplateKoddel;
            Kontodel9: ITemplateKoddel;
            Kontodel10: ITemplateKoddel;
          } = {
            Kontodel1: {
              kontodel: kontodelWithLocalusage
                ? {
                    id: kontodelWithLocalusage?.id,
                    BENAMNING: kontodelWithLocalusage?.benamning,
                    KONTODEL: kontodelWithLocalusage?.kontodel,
                    KontodelBenamning:
                      kontodelWithLocalusage?.kontodel +
                      ' - ' +
                      kontodelWithLocalusage?.benamning,
                    __typename: '',
                  }
                : {
                    id: templateRow?._Associations?.Kontodel1?.id,
                    BENAMNING: templateRow?._Associations?.Kontodel1?.BENAMNING,
                    KONTODEL: templateRow?._Associations?.Kontodel1?.KONTODEL,
                    KontodelBenamning:
                      templateRow?._Associations?.Kontodel1?.KontodelBenamning,
                    __typename:
                      templateRow?._Associations?.Kontodel1?.__typename ?? '',
                  },
              options: {
                canChange: templateRow?.KAN_ANDRAS_1,
                validInterval: templateRow?.GILTIG_INTERVALL_1,
                conditions: templateRow?.VILLKOR_1,
              },
            },
            Kontodel2: {
              kontodel: templateRow?._Associations?.Kontodel2,
              options: {
                canChange: templateRow?.KAN_ANDRAS_2,
                validInterval: templateRow?.GILTIG_INTERVALL_2,
                conditions: templateRow?.VILLKOR_2,
              },
            },
            Kontodel3: {
              kontodel: templateRow?._Associations?.Kontodel3,
              options: {
                canChange: templateRow?.KAN_ANDRAS_3,
                validInterval: templateRow?.GILTIG_INTERVALL_3,
                conditions: templateRow?.VILLKOR_3,
              },
            },
            Kontodel4: {
              kontodel: templateRow?._Associations?.Kontodel4,
              options: {
                canChange: templateRow?.KAN_ANDRAS_4,
                validInterval: templateRow?.GILTIG_INTERVALL_4,
                conditions: templateRow?.VILLKOR_4,
              },
            },
            Kontodel5: {
              kontodel: templateRow?._Associations?.Kontodel5,
              options: {
                canChange: templateRow?.KAN_ANDRAS_5,
                validInterval: templateRow?.GILTIG_INTERVALL_5,
                conditions: templateRow?.VILLKOR_5,
              },
            },
            Kontodel6: {
              kontodel: templateRow?._Associations?.Kontodel6,
              options: {
                canChange: templateRow?.KAN_ANDRAS_6,
                validInterval: templateRow?.GILTIG_INTERVALL_6,
                conditions: templateRow?.VILLKOR_6,
              },
            },
            Kontodel7: {
              kontodel: templateRow?._Associations?.Kontodel7,
              options: {
                canChange: templateRow?.KAN_ANDRAS_7,
                validInterval: templateRow?.GILTIG_INTERVALL_7,
                conditions: templateRow?.VILLKOR_7,
              },
            },
            Kontodel8: {
              kontodel: templateRow?._Associations?.Kontodel8,
              options: {
                canChange: templateRow?.KAN_ANDRAS_8,
                validInterval: templateRow?.GILTIG_INTERVALL_8,
                conditions: templateRow?.VILLKOR_8,
              },
            },
            Kontodel9: {
              kontodel: templateRow?._Associations?.Kontodel9,
              options: {
                canChange: templateRow?.KAN_ANDRAS_9,
                validInterval: templateRow?.GILTIG_INTERVALL_9,
                conditions: templateRow?.VILLKOR_9,
              },
            },
            Kontodel10: {
              kontodel: templateRow?._Associations?.Kontodel10,
              options: {
                canChange: templateRow?.KAN_ANDRAS_10,
                validInterval: templateRow?.GILTIG_INTERVALL_10,
                conditions: templateRow?.VILLKOR_10,
              },
            },
          };

          return {
            andelProcent: templateRow.ANDEL_PROCENT,
            debetOrKredit: templateRow.DEB_KRED,
            id: id,
            kontodelar: kontodelar,
            mallradLopnr: templateRow.LOPNR,
            kommentar: templateRow.KOMMENTAR,
            methodOfLiquidation: kontodelWithLocalusage?.localUsage?.[0],
            ordningsNr: templateRow.ORDNINGS_NR,
          };
        }
      );
      setTemplateRows(newRows);
      return newRows;
    },
    [bokforderKodplan, formContext?.isNew, konteringContext]
  );

  /** Submits rows to formcontext based on input array.
   * Expects an array from either makeTemplateRowsArray or from the state templateRows in BokforderContext
   */
  const createTemplateRows = useCallback(
    (newRows: ITemplateRow[]) => {
      const newValues: FormUpdateAssociatonType[][] = [[]];
      newRows?.forEach(row => {
        newValues.push(makeNewRow(row.id));

        if (row.methodOfLiquidation != undefined) {
          newValues.push([
            {
              associationName: 'Rader',
              operation: 'Add_Values',
              id: row.id,
              values: {
                LIKVIDSATT: row.methodOfLiquidation.MALL_TYP,
              },
            },
          ]);
        }

        for (let kontodel in row?.kontodelar) {
          const newKontodel = (
            row?.kontodelar as Record<string, ITemplateKoddel>
          )?.[kontodel]?.kontodel;

          if (newKontodel) {
            newValues.push([
              {
                associationName: 'Rader',
                operation: 'Add_Values',
                id: row.id,
              },
              {
                associationName: `${kontodel}`,
                operation: 'Ref',
                id: newKontodel?.id ?? null,
                values: newKontodel?.id
                  ? {
                      id: newKontodel?.id,
                      KontodelBenamning: newKontodel?.KontodelBenamning, //Både id och benämning behövs för att inte useAssociationValues försöker hämta den saknade datan och ställa frågor i onödan.
                    }
                  : null,
              },
            ]);
          }
        }

        newValues.push([
          {
            associationName: 'Rader',
            operation: 'Add_Values',
            id: row.id,
            values: {
              MALLRAD_LOPNR: row.mallradLopnr,
              TEXT: row.kommentar,
            },
          },
        ]);
      });
      formContextUpdate?.(newValues, true);

      setNewRowIndex(newRows?.length ?? 0 + 1);
    },
    [makeNewRow, formContextUpdate]
  );

  const onTemplateChange = useCallback(
    (
      option:
        | BokforderSettingsQuery_db_EKBokforingsmall_All
        | BokforderSettingsQuery_db_EKBokforingsmall_All[]
        | null
    ) => {
      formContextDispatch?.({ type: 'RESET' });
      if (!Array.isArray(option)) {
        const text = option?.TEXT ?? '';
        const newParamValues =
          option?._Associations?.Parametrar_All?.reduce((prev, param) => {
            if (!param) {
              return prev;
            }

            return { ...prev, [param.PARAM_NAME]: '' };
          }, {}) ?? {};

        formContextUpdate?.(
          [
            {
              operation: 'OwnFields',
              values: {
                id: formContext?.data?.id ?? '',
                PARAMVALUES: createParamString(newParamValues),
                TEXT: createLabelText(text, newParamValues),
              },
            },
            {
              associationName: 'Bokforingsmall',
              operation: 'Ref',
              values: { id: option?.id ?? '' },
            },
          ],
          true
        );

        const newRows = makeTemplateRowsArray(option);
        createTemplateRows(newRows);
      }
    },
    [
      createTemplateRows,
      formContext?.data?.id,
      formContextUpdate,
      makeTemplateRowsArray,
      formContextDispatch,
    ]
  );

  const deleteBokforderRad = useCallback(
    (radID: string, ignoreFormHasChanged?: boolean) => {
      const updateArray: FormUpdateAssociatonType[] = [
        {
          operation: 'Delete_Values',
          associationName: 'Rader',
          id: radID,
        },
      ];

      formContext?.formStateDispatch({
        type: 'UPDATE',
        value: getFormUpdateValue(updateArray, formContext.data ?? {}),
        customValues: {
          lastUpdatedBokfOrderRad: null,
        },
      });
    },
    [formContext]
  );

  const addOrUpdateMessage = useCallback(
    (message: string, id: string, _version?: number) => {
      const updateValues: FormUpdateAssociatonType[] = [];
      if (id.startsWith(AUTOMATICALLY_ADDED_VALUE_PREFIX)) {
        let messageValues: FormUpdateAssociatonType = {
          associationName: 'Meddelande',
          operation: 'Add_Values',
          id: id,
          values: {
            id: id,
            MEDDELANDE: message,
            AVSANDAR_TYP:
              formContext?.isNew ||
              formContext?.data?._Associations?.Bestallare?.id === userID
                ? TEDEKBokforderMeddelandeAVSANDAR_TYPEnum.FRAN_BESTALLARE
                : TEDEKBokforderMeddelandeAVSANDAR_TYPEnum.FRAN_ATTESTANT,
          },
        };

        const messageRef: FormUpdateAssociatonType = {
          associationName:
            formContext?.isNew ||
            formContext?.data?._Associations?.Bestallare?.id === userID
              ? 'Bestallare'
              : 'Attestant',
          operation: 'Ref',
          id: userID ?? '',
        };

        updateValues.push(messageValues, messageRef);
      } else {
        let messageValues: FormUpdateAssociatonType = {
          associationName: 'Meddelande',
          operation: 'Update_Values',
          id: id,
          values: {
            id: id,
            MEDDELANDE: message,
            _version: _version ?? 1,
          },
        };

        updateValues.push(messageValues);
      }

      formContextUpdate?.(updateValues);
    },
    [
      formContext?.data?._Associations?.Bestallare?.id,
      formContext?.isNew,
      formContextUpdate,
      userID,
    ]
  );

  const deleteMessage = useCallback(
    (messageID: string) => {
      formContext?.update([
        {
          operation: 'Delete_Values',
          associationName: 'Meddelande',
          id: messageID,
        },
      ]);
    },
    [formContext]
  );

  const templates = useMemo(
    () =>
      mergeSort(
        props.settingsQueryResult?.data?.db?.EKBokforingsmall_All ?? [],
        (a, b) => {
          if (!a || !b) {
            return 0;
          }

          if (a.BENAMNING > b.BENAMNING) {
            return 1;
          }
          if (a.BENAMNING < b.BENAMNING) {
            return -1;
          }

          return 0;
        }
      ),
    [props.settingsQueryResult?.data]
  );

  const resetBokforder = useCallback(() => {
    formContextDispatch?.({ type: 'RESET' });

    formContextUpdate?.([
      {
        operation: 'OwnFields',
        values: {
          id: formContext?.data?.id ?? '',
          PARAMVALUES: null,
          TEXT: null,
          BOKF_DATUM: null,
        },
      },
      {
        associationName: 'Bokforingsmall',
        operation: 'Ref',
        values: null,
      },
    ]);
  }, [formContext?.data?.id, formContextDispatch, formContextUpdate]);

  const currentTemplate = useMemo(
    () => templates.find(template => template.id === templateID) ?? null,
    [templateID, templates]
  );

  // Synka setBokforderVariant
  if (
    (bokforderVariant === null ||
      !equals(prevSelectedDetail, props.selectedDetail)) &&
    !formContext?.mutationLoading &&
    !formContext?.formState.loading
  ) {
    const bfoVariant = getBokforderVariant(formContext?.data, location.search);
    setPrevSelectedDetail(props.selectedDetail);
    setBokforderVariant(bfoVariant);
  }

  if (formContext?.isNew && bokforderWrapperContext.currentUser) {
    const type = getBokforderTypeFromSearchParams(location.search);

    if (
      type === TEDEKBokforderTYPEnum.BOKFORINGSORDER &&
      !bokforderWrapperContext.currentUser.BESTALLARE_BOKFORDER &&
      !bokforderWrapperContext.isEconomyPersonnel
    ) {
      if (
        !bokforderWrapperContext.currentUser._Associations?.Kontobegransningar_All?.some(
          kodbeh => kodbeh.FOR_BOKFORDER
        ) ||
        urlParams.bokfar == null ||
        urlParams.variant != DefaultBfoVariantEnum.VERIFIKATION ||
        urlParams.vernr == null
      ) {
        const pathArray = location.pathname.split('/').slice(0, -1);

        navigate(pathArray.join('/'));
      }
    }

    if (
      type === TEDEKBokforderTYPEnum.UTANORDNING &&
      !bokforderWrapperContext.currentUser.BESTALLARE_UTANORDNING
    ) {
      if (
        !bokforderWrapperContext.currentUser._Associations?.Kontobegransningar_All?.some(
          kodbeh => kodbeh.FOR_UTANORDNING
        )
      ) {
        const pathArray = location.pathname.split('/').slice(0, -1);

        navigate(pathArray.join('/'));
      }
    }
  }

  // Sätter hantera verifikation i ett begränsatläge om man kommer från EkA och inte är beställare
  if (
    isEditMode &&
    bokforderWrapperContext.currentUser &&
    limitedCreateMode == null
  ) {
    setLimitedCreateMode(
      !bokforderWrapperContext.currentUser.BESTALLARE_BOKFORDER &&
        !bokforderWrapperContext.isEconomyPersonnel
    );

    if (isFromEkA) {
      localStorage.removeItem(BFO_OPEN_FROM_EKA);
    }
  }

  const value: IBokforderContext = useMemo(
    () => ({
      addOrUpdateMessage,
      allBokforderUsersWithKodbeh,
      allUtanordningUsersWithKodbeh,
      areYouSureModalCallback,
      areYouSureModalOpen,
      bokforderDate,
      bokforderKodplan,
      bokforderVariant,
      currentTemplate,
      createTemplateRows,
      deleteBokforderRad,
      deleteMessage,
      editMessageID: props.editMessageID,
      everyReservAttesterIsAttesterade,
      focusRef,
      getKonteringsmall,
      hasVerifikationFakturabild,
      hasVerifikationUnderlag,
      importDialogOpen,
      isAttestant,
      isFromEkA,
      isEditMode,
      isReservForAttestant,
      isReservForKontrollattestant,
      isVerifikation,
      konteringsmallarData,
      konteringsmallarLoading,
      limitedCreateMode,
      makeNewRow,
      makeTemplateRowsArray,
      methodOfLiquidation,
      newRowIndex,
      onTemplateChange,
      paramValues,
      setEditMessageID: props.setEditMessageID,
      resetBokforder,
      setAreYouSureModalCallback,
      setAreYouSureModalOpen,
      setBokforderVariant,
      setHasVerifikationFakturabild,
      setHasVerifikationUnderlag,
      setImportDialogOpen,
      setIsFromEkA,
      setIsEditMode,
      setNewRowIndex,
      setParamValues,
      setTillgohavandeKundTyp,
      showAttestantKonteraSwitch,
      tillgodohavandeKundTyp,
      templates,
      templateRows,
      updateRow,
      urlParams,
    }),
    [
      addOrUpdateMessage,
      allBokforderUsersWithKodbeh,
      allUtanordningUsersWithKodbeh,
      areYouSureModalCallback,
      areYouSureModalOpen,
      bokforderDate,
      bokforderKodplan,
      bokforderVariant,
      currentTemplate,
      createTemplateRows,
      deleteBokforderRad,
      deleteMessage,
      props.editMessageID,
      props.setEditMessageID,
      everyReservAttesterIsAttesterade,
      getKonteringsmall,
      hasVerifikationFakturabild,
      hasVerifikationUnderlag,
      importDialogOpen,
      isAttestant,
      isFromEkA,
      isEditMode,
      isReservForAttestant,
      isReservForKontrollattestant,
      isVerifikation,
      konteringsmallarData,
      konteringsmallarLoading,
      limitedCreateMode,
      makeNewRow,
      makeTemplateRowsArray,
      methodOfLiquidation,
      newRowIndex,
      onTemplateChange,
      paramValues,
      resetBokforder,
      showAttestantKonteraSwitch,
      tillgodohavandeKundTyp,
      templates,
      templateRows,
      updateRow,
      urlParams,
    ]
  );

  return (
    <BokforderContext.Provider value={value}>
      {props.children}
    </BokforderContext.Provider>
  );
};

export default BokforderContextManager;
